'use client';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType } from '@repo/ui/src/types/image';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { useRef, useEffect, useState } from 'react';
import { Tout, AccCard, Image, Overlay } from './styles';

interface CardProps {
  img: {
    image: MediaType;
    altTag: string;
  };
  toutContent: ToutContentProps;
  largeCard: boolean;
  reverse?: boolean;
}

const GridCard = ({ img, toutContent, largeCard, reverse }: CardProps) => {
  const ref = useRef<any>(null);
  const [translateHeight, setHeight] = useState(0);
  const imageUrl = buildImageSrc(img.image, 700, 1, 1);
  useEffect(() => {
    const element = ref.current;
    if (element) {
      const bottomContent = element.querySelector('.bottom-content');
      const bottomContentHeight = bottomContent?.clientHeight;
      if (bottomContentHeight) {
        setHeight(bottomContentHeight);
      }
    }
  }, []);

  return (
    <AccCard
      className="accCard"
      ref={ref}
      translateHeight={translateHeight}
      tabIndex={0}
      reverse={reverse}
    >
      <Image src={imageUrl} alt="" />
      <Overlay />
      <Tout
        dark
        headingStyleVariant="h5"
        heading={toutContent.heading}
        {...toutContent}
        className="tout"
        largeCard={largeCard}
        align="left"
        divider
        buttonSize="small"
      />
    </AccCard>
  );
};

export default GridCard;
